import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import InformationIcon from 'assets/icons/information-icon.svg';
import ExclamationIcon from 'assets/icons/exclamation.svg';
import CheckIcon from 'assets/icons/check.svg';

import * as S from './styles';

const Overlay = ({ type, color, isOpen, children, text, customSvg }) => {
  const [overlayType, setOverlayType] = useState('');
  const [icon, setIcon] = useState('');

  useEffect(() => {
    const changeOverlayType = value => {
      switch (value) {
        case 'information':
          setOverlayType('information');
          setIcon(InformationIcon);
          break;
        case 'warning':
          setOverlayType('warning');
          setIcon(ExclamationIcon);
          break;
        case 'success':
          setOverlayType('success');
          setIcon(CheckIcon);
          break;
        case 'other':
          setOverlayType('other');
          break;
        default:
          return '';
      }
    };
    changeOverlayType(type);
  }, [type]);

  return (
    <S.Container modalVisibility={isOpen}>
      <S.Overlay>
        {customSvg || <S.OverlayIcon src={icon} />}
        <S.OverlayText
          customColor={color}
          className={`overlay-${overlayType}-text`}
        >
          {text}
        </S.OverlayText>
        <S.OverlayButtons className={`overlay-${overlayType}-buttons`}>
          {children}
        </S.OverlayButtons>
      </S.Overlay>
    </S.Container>
  );
};

export default Overlay;

Overlay.defaultProps = {
  color: '#0083CA',
  isOpen: false,
  customSvg: null,
};

Overlay.propTypes = {
  type: PropTypes.string.isRequired,
  color: PropTypes.string,
  isOpen: PropTypes.bool,
  text: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  customSvg: PropTypes.instanceOf(Element),
};
